import { bl_fi_deposit_register_hdr_RowClass } from '../../dbschema/bl_fi_deposit_register_hdr.model';
import { BaseContainerModel } from '../base-container.model';

export class DepositRegisterContainerModel extends BaseContainerModel {
  bl_fi_deposit_register_hdr: bl_fi_deposit_register_hdr_RowClass = new bl_fi_deposit_register_hdr_RowClass();
}
